/**
 * Cart count sync bridge.
 *
 * ReCharge (and other apps) can mutate the cart without firing the theme's
 * `cartLinesUpdate` event, so the header <cart-icon> badge never refreshes
 * until the next full page load. This watches every cart-mutating request —
 * whoever makes it (theme, ReCharge, quick-add, etc.) — and re-syncs each
 * badge from /cart.js. It only reads responses; it never alters them, so it
 * doesn't interfere with the cart flow itself.
 */
(function () {
  if (window.__core7CartCountSync) return;
  window.__core7CartCountSync = true;

  // Shopify cart mutation endpoints (with or without the .js suffix).
  var CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/i;

  var syncTimer = null;
  function scheduleSync() {
    if (syncTimer) return;
    syncTimer = setTimeout(function () {
      syncTimer = null;
      syncCartBubble();
    }, 100);
  }

  function syncCartBubble() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        var count = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
        updateBadges(count);
      })
      .catch(function () {
        /* ignore — leave the badge as-is on failure */
      });
  }

  // Mirror the rendering logic in cart-icon.js so the badge matches exactly.
  function updateBadges(count) {
    var visibleValue = count < 100 ? String(count) : '';

    document.querySelectorAll('cart-icon').forEach(function (icon) {
      var bubble = icon.querySelector('[ref="cartBubble"]');
      var countEl = icon.querySelector('[ref="cartBubbleCount"]');

      if (countEl) {
        countEl.textContent = visibleValue;
        countEl.classList.toggle('hidden', count === 0);
      }
      if (bubble) bubble.classList.toggle('visually-hidden', count === 0);
      icon.classList.toggle('header-actions__cart-icon--has-cart', count > 0);
    });

    // Keep the value cart-icon.js restores from on bfcache/pageshow in sync.
    try {
      sessionStorage.setItem(
        'cart-count',
        JSON.stringify({ value: visibleValue, timestamp: Date.now() })
      );
    } catch (e) {
      /* ignore */
    }
  }

  function urlOf(input) {
    if (typeof input === 'string') return input;
    if (input && typeof input.url === 'string') return input.url;
    return '';
  }

  // --- Watch fetch ---
  if (typeof window.fetch === 'function') {
    var originalFetch = window.fetch;
    window.fetch = function () {
      var promise = originalFetch.apply(this, arguments);
      try {
        if (CART_MUTATION.test(urlOf(arguments[0]))) {
          promise.then(function () {
            scheduleSync();
          }, function () {});
        }
      } catch (e) {
        /* ignore */
      }
      return promise;
    };
  }

  // --- Watch XMLHttpRequest (in case an app uses XHR instead of fetch) ---
  var XHR = window.XMLHttpRequest;
  if (XHR && XHR.prototype) {
    var open = XHR.prototype.open;
    XHR.prototype.open = function (method, url) {
      try {
        this.__core7CartSyncMatch = CART_MUTATION.test(url || '');
      } catch (e) {
        /* ignore */
      }
      return open.apply(this, arguments);
    };

    var send = XHR.prototype.send;
    XHR.prototype.send = function () {
      try {
        if (this.__core7CartSyncMatch) {
          this.addEventListener('loadend', scheduleSync);
        }
      } catch (e) {
        /* ignore */
      }
      return send.apply(this, arguments);
    };
  }
})();
